import { NgModule } from '@angular/core';
import { CurrencyFormatPipe } from '../pipes/currency-settings.pipe';

@NgModule({
  declarations: [CurrencyFormatPipe],
  exports: [CurrencyFormatPipe],
  providers: [],
})
export class CurrencyModule {}
